module.exports = __webpack_public_path__ + "static/media/unavailable-ribbon.fcb53c2e.png";